import React from 'react';
import PropTypes from 'prop-types';

import GoogleSemMessage from '@stubhub/react-google-sem-message';
import {connect, ssr_wait} from '@stubhub/react-store-provider';

import controller from './controller';
import Nav from './nav';

import '../styles/index.scss';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      /**
       * Whether modal search is active.
       * NOTE - This can can be true even if style is expanded, if screen size is small enough.
       *
       */
      isModalSearchActive: false,
    };
  }

  @ssr_wait
  init() {
    const {globalRegistry} = this.context;
    if (globalRegistry.getFeatureValue('common.exposeExpandedNavMenu')) {
      const {loadMultiLayeredMenu} = this.props;

      return loadMultiLayeredMenu();
    }

    return Promise.resolve();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  /**
   * Callback Method to update the `isModalSearchActive` state variable on Header component.
   * @param isActive [boolean] The flag denoting if the Modal Search is active or not.
   *
   */
  onModalSearchActiveChanged = (isActive) => {
    this.setState({
      isModalSearchActive: isActive,
    });
  };

  render() {
    const {isModalSearchActive} = this.state;
    const {
      screenSize,
      searchBarStyle,
      showSearchBarModal,
      onNavMenuStateChange,
      searchpage,
      categorypage,
      performerpage,
      langSelector,
      onlyNavSecondary,
      noNavSecondary,
      selectedCurrency,
      hideOnMweb,
      handleImportantIconClick,
      showImportantInfoModal,
    } = this.props;

    // Header class
    let headerCls = 'mh__container';
    headerCls += isModalSearchActive ? ' mh__container--searchActive' : '';
    headerCls += noNavSecondary ? ' mh__noNav' : '';
    headerCls += hideOnMweb && screenSize === 'small' ? ' mh__hidden' : '';

    // TODO: remove this condition once the minimal merch header has been adapted for desktop breakpoints
    let searchBarStyleType = searchBarStyle;
    if (searchBarStyle === 'modal' && screenSize !== 'small') {
      searchBarStyleType = 'expanded';
    }

    return [
      <header
        key="header"
        data-testid="header"
        className={`mh event_merch_header ${headerCls} mh__searchStyle--${searchBarStyleType}`}
      >
        <GoogleSemMessage isFeatureOn />
        <Nav
          searchBarStyle={searchBarStyleType}
          searchpage={searchpage}
          categorypage={categorypage}
          performerpage={performerpage}
          langSelector={langSelector}
          screenSize={screenSize}
          isModalSearchActive={isModalSearchActive}
          onModalSearchActiveChanged={this.onModalSearchActiveChanged}
          showSearchBarModal={showSearchBarModal}
          onNavMenuStateChange={onNavMenuStateChange}
          onlyNavSecondary={onlyNavSecondary}
          noNavSecondary={noNavSecondary}
          selectedCurrency={selectedCurrency}
          showImportantInfoIcon={showImportantInfoModal}
          handleImportantIconClick={handleImportantIconClick}
        />
      </header>,
    ];
  }
}

Header.propTypes = {
  /** Style for the search bar */
  searchBarStyle: PropTypes.string,

  /** Screen size */
  screenSize: PropTypes.string,

  /** Callback to update the state of the Nav Menu */
  onNavMenuStateChange: PropTypes.func,

  /** Callback function to load multi layered menu */
  loadMultiLayeredMenu: PropTypes.func,

  /** Callback function to show the search bar modal */
  showSearchBarModal: PropTypes.bool,

  /** Whether the page is search page */
  searchpage: PropTypes.bool,

  /** Whether the page is category page */
  categorypage: PropTypes.bool,

  /** Whether the page is performer page */
  performerpage: PropTypes.bool,

  /** Whether to show the language selector */
  langSelector: PropTypes.bool,

  /** Whether to show only the secondary nav */
  onlyNavSecondary: PropTypes.bool,

  /** Whether to show no secondary nav */
  noNavSecondary: PropTypes.bool,

  /** The selected currency */
  selectedCurrency: PropTypes.string,

  /** Whether to hide on mobile web */
  hideOnMweb: PropTypes.bool,

  /** Callback function to handle important icon click */
  handleImportantIconClick: PropTypes.func,

  /** Whether to show important info modal */
  showImportantInfoModal: PropTypes.bool,
};

Header.defaultProps = {
  searchBarStyle: 'expanded',
  screenSize: __CLIENT__ ? 'small' : 'medium',
};

Header.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default connect(controller)(Header);
